import { render, staticRenderFns } from "./ShareholderCount.vue?vue&type=template&id=d9a793e6&scoped=true"
import script from "./ShareholderCount.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareholderCount.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ShareholderCount.vue?vue&type=style&index=0&id=d9a793e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a793e6",
  null
  
)

export default component.exports